import type { ButtonSize } from '@timelyapp/react';
import classNames from 'classnames';

import React, { forwardRef } from 'react';
import type { HourState } from 'redux/modules/hourStates.schema';
import { getHourStateIcon } from 'routes/hourStates/HourStateIcon';
import { prefixHexColor } from 'utils/colors';
import { colorBackgroundMap, defaultColor } from './HourStateLabel.constants';
import styles from './HourStateLabel.module.scss';

export const hourStateButtonClass = styles.button;

interface HourStateLabelProps {
  className?: string;
  iconOnly?: boolean;
  inline?: boolean;
  size?: 'xsmall' | ButtonSize;
  state: HourState;
  style?: React.CSSProperties;
}

const HourStateLabel = forwardRef<HTMLSpanElement, HourStateLabelProps>(
  ({ className, iconOnly, inline, size = 'medium', state, style, ...rest }, ref) => {
    const icon = getHourStateIcon(state);
    const color = prefixHexColor(state.color || defaultColor);

    return (
      <span
        ref={ref}
        className={classNames(styles.container, styles[`size-${size}`], className, {
          [styles.inline]: inline,
          [styles.hasIcon]: icon,
          [styles.iconOnly]: iconOnly,
        })}
        style={{
          color: inline ? color : undefined,
          ...style,
        }}
        {...rest}
      >
        {icon}
        {!iconOnly && state.name}
        {inline && (
          <span
            className={styles.background}
            style={{ backgroundColor: colorBackgroundMap[color] }}
          />
        )}
      </span>
    );
  }
);

export default HourStateLabel;
